// extracted by mini-css-extract-plugin
module.exports = {"container":"Intro_container__3gZVo","descr":"Intro_descr__1OduV","highlight":"Intro_highlight__1pUwm"};